export default "__VITE_ASSET__Bz73LN0h__"